import ArtifactGroupType from "../base/ArtifactGroupType";


const AnubisSarcophagus = {
  id: '108',
  name: 'Anubis Sarcophagus',
  groupIcon: 'TreasuresOfTheNile',
  type: ArtifactGroupType.TREASURES_OF_THE_NILE,
  icon: 'AnubisSarcophagus',
  power: 25
};

export default AnubisSarcophagus;
